import React from 'react';
import {
    Typography,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    Box,
} from '@mui/material';
import { scroller } from 'react-scroll';
import { ArrowForward, ExpandMore } from '@mui/icons-material';
import cover from '../../assets/images/cover.jpg';

const Fade = require('react-reveal/Fade');

const cleaning = [
    '1 chimney: €70',
    'extra chimneys: + €50',
    'Pellet stove: €150',
];
const cleaningSecondary = [
    '',
    'Per household',
    '',
];

const openFires = [
    'Open Fire',
    'Solid Fuel Stove',
    'Pellet Stove',
    'Stove Rope: €20',
];

const survey = ['Camera Survey: €160'];

export const Services: React.FC = () => {
    const handleExpandClick = () => {
        scroller.scrollTo('gallery', {
            duration: 1500,
            delay: 100,
            smooth: true,
        });
    };

    return (
        <Box
            id='services'
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundRepeat: 'no-repeat',
                backgroundColor: 'rgb(232, 232, 232)',
                '& h4': {
                    fontFamily: 'Raleway',
                    textTransform: 'uppercase',
                    marginTop: '60px',
                },
                '& h5': {
                    fontFamily: 'Raleway',
                    textTransform: 'uppercase',
                    padding: '10px',
                    textAlign: 'center',
                },
            }}
        >
            <Typography variant='h4' sx={{ color: '#4a4a4a' }}>
                Services
            </Typography>
            <Box component='hr' sx={{ width: '40px', border: 0, borderTop: '2px solid #653A96' }} />

            <Typography sx={{ color: '#4a4a4a', padding: '20px', width: '50%', textAlign: 'center' }}>
                How much does it cost ?
            </Typography>

            <Box component='hr' sx={{ width: '40px', border: 0, borderTop: '2px solid #4a4a4a' }} />

            <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', flexWrap: 'wrap', gap: 8, mt: 3, mb: 1, width: '100%' }}>
                <Paper
                    elevation={3}
                    sx={{
                        transition: 'all .2s ease-in-out',
                        width: '300px',
                        height: '480px',
                        '&:hover': { transform: 'scale(1.08)' },
                        '& img': {
                            marginTop: '-40px',
                            backgroundColor: '#653A96',
                            borderRadius: 50,
                            width: '80px',
                            height: '80px',
                        },
                    }}
                >
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <img alt='stoves' src={cover} />
                    </Box>
                    <Typography variant='h5'>Cleaning services</Typography>
                    <Box component='hr' sx={{ width: '40px', border: 0, borderTop: '2px solid #4a4a4a' }} />

                    <List>
                        {cleaning.map((item, index) => (
                            <Fade top cascade duration={index * 300} key={item}>
                                <ListItem>
                                    <ListItemIcon>
                                        <ArrowForward fontSize='small' sx={{ color: '#653A96' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={item} secondary={cleaningSecondary[index]} />
                                </ListItem>
                            </Fade>
                        ))}
                    </List>
                </Paper>

                <Paper
                    elevation={3}
                    sx={{
                        transition: 'all .2s ease-in-out',
                        width: '300px',
                        height: '480px',
                        '&:hover': { transform: 'scale(1.08)' },
                        '& img': {
                            marginTop: '-40px',
                            backgroundColor: '#653A96',
                            borderRadius: 50,
                            width: '80px',
                            height: '80px',
                        },
                    }}
                >
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <img alt='Open Fires' src={cover} />
                    </Box>
                    <Typography variant='h5'>Chimney Services</Typography>
                    <Box component='hr' sx={{ width: '40px', border: 0, borderTop: '2px solid #4a4a4a' }} />

                    <List>
                        {openFires.map((item, index) => (
                            <Fade top cascade duration={index * 300} key={item}>
                                <ListItem>
                                    <ListItemIcon>
                                        <ArrowForward fontSize='small' sx={{ color: '#653A96' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={item} />
                                </ListItem>
                            </Fade>
                        ))}
                    </List>
                </Paper>

                <Paper
                    elevation={3}
                    sx={{
                        transition: 'all .2s ease-in-out',
                        width: '300px',
                        height: '480px',
                        '&:hover': { transform: 'scale(1.08)' },
                        '& img': {
                            marginTop: '-40px',
                            backgroundColor: '#653A96',
                            borderRadius: 50,
                            width: '80px',
                            height: '80px',
                        },
                    }}
                >
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <img alt='Survey' src={cover} />
                    </Box>
                    <Typography variant='h5'>Camera Survey</Typography>
                    <Box component='hr' sx={{ width: '40px', border: 0, borderTop: '2px solid #4a4a4a' }} />

                    <List>
                        {survey.map((item, index) => (
                            <Fade top cascade duration={index * 300} key={item}>
                                <ListItem>
                                    <ListItemIcon>
                                        <ArrowForward fontSize='small' sx={{ color: '#653A96' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={item} />
                                </ListItem>
                            </Fade>
                        ))}
                    </List>
                </Paper>
            </Box>
            <IconButton sx={{ mt: '20px', color: '#4a4a4a', zIndex: 2 }} onClick={handleExpandClick}>
                <ExpandMore fontSize='large' />
            </IconButton>
        </Box>
    );
};